import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export function useItemImages(itemId: string) {
  return useQuery({
    queryKey: ['itemImages', itemId],
    queryFn: () => apiClient.listItemImages(itemId),
    enabled: !!itemId,
  });
}

export function useUploadItemImage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, file }: { itemId: string; file: File | Blob }) =>
      apiClient.uploadItemImageMulti(itemId, file),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['itemImages', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['inventory', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
    },
  });
}

export function useDeleteItemImage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, imageId }: { itemId: string; imageId: string }) =>
      apiClient.deleteItemImageById(itemId, imageId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['itemImages', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['inventory', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
    },
  });
}

export function useSetPrimaryImage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, imageId }: { itemId: string; imageId: string }) =>
      apiClient.setItemImagePrimary(itemId, imageId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['itemImages', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['inventory', variables.itemId] });
      queryClient.invalidateQueries({ queryKey: ['inventory'] });
    },
  });
}

export function useReorderImages() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, orderedIds }: { itemId: string; orderedIds: string[] }) =>
      apiClient.reorderItemImages(itemId, orderedIds),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['itemImages', variables.itemId] });
    },
  });
}
